import { render, staticRenderFns } from "./RemoteDesk.vue?vue&type=template&id=733f01e6&scoped=true"
import script from "./RemoteDesk.vue?vue&type=script&lang=js"
export * from "./RemoteDesk.vue?vue&type=script&lang=js"
import style0 from "./RemoteDesk.vue?vue&type=style&index=0&id=733f01e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733f01e6",
  null
  
)

export default component.exports